function page(path) {
	return () => import(/* webpackChunkName: '' */ `~/views/${path}`).then(m => m.default || m)
}

export default [
	{ path: '/', name: '/', component: page('master.vue') },
	{ path: '/login', name: 'login', component: page('auth/login.vue') },
	{ path: '/bookings', name: 'bookings', component: page('bookings/index.vue') },
	{ path: '/services', name: 'services', component: page('services/index.vue') },
	{ path: '/opnhrs', name: 'opn_hrs', component: page('opnhrs/index.vue') },
	{ path: '/absences', name: 'absences', component: page('absences/index.vue') },
	{ path: '/customers', name: 'customers', component: page('customers/index.vue') },
	{ path: '/settings', name: 'settings', component: page('settings/index.vue') },

	{ path: '*', component: page('errors/404.vue') }
]
